var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completo",style:(_vm.myStyle)},[_c('p',{style:(_vm.valueStyle),attrs:{"id":"value1-value-label"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }